var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#2F78EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1803 9.51774C17.9582 9.41828 18.7451 9.73636 19.5447 10.4887L19.5457 10.4896C20.3479 11.2483 20.7132 12.018 20.6584 12.8019C20.6054 13.5594 20.1663 14.2005 19.6655 14.7296M19.6655 14.7296L14.1949 20.52C14.0407 20.688 13.833 20.8302 13.6362 20.9355C13.4368 21.0421 13.2061 21.1333 12.9896 21.1718L12.9863 21.1724L10.8404 21.5389C10.32 21.6287 9.82101 21.4986 9.46554 21.1615C9.11057 20.8249 8.95371 20.334 9.01182 19.811L9.01199 19.8095L9.25973 17.6401C9.2885 17.4243 9.36865 17.1908 9.46312 16.9882C9.55725 16.7864 9.68568 16.5723 9.83767 16.4105L9.83865 16.4095L15.312 10.6162C15.813 10.0869 16.4287 9.61386 17.1803 9.51774M16.0385 11.3033L10.5665 17.0952C10.5119 17.1535 10.4368 17.2663 10.3694 17.4109C10.3032 17.5528 10.2635 17.684 10.2516 17.7684L10.0057 19.9214L10.0056 19.9221C9.97729 20.1787 10.057 20.3443 10.1537 20.4359C10.2499 20.5271 10.4175 20.5971 10.6705 20.5535L10.6712 20.5533L12.816 20.187C12.8995 20.1719 13.0282 20.1266 13.1647 20.0536C13.3031 19.9796 13.4072 19.8998 13.4593 19.8427L13.4653 19.8361L18.9387 14.0428C19.3844 13.5719 19.6321 13.1428 19.6608 12.7322C19.6877 12.3479 19.5297 11.851 18.8591 11.2167C18.1922 10.5893 17.6893 10.4608 17.3072 10.5097C16.8989 10.5619 16.4841 10.8327 16.0385 11.3033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6851 11.4322C14.958 11.3897 15.2136 11.5764 15.2561 11.8492C15.5076 13.463 16.8172 14.6981 18.4455 14.8621C18.7203 14.8897 18.9206 15.1349 18.8929 15.4096C18.8652 15.6844 18.6201 15.8847 18.3453 15.857C16.267 15.6477 14.59 14.0694 14.2681 12.0032C14.2255 11.7303 14.4123 11.4747 14.6851 11.4322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTableIcon);
export default __webpack_public_path__ + "static/media/editTableIcon.48c7d5cad0b6e350589be8f169f658aa.svg";
export { ForwardRef as ReactComponent };